import React from 'react';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { Dialog, DialogContent, DialogTitle } from './ui/dialog';
import { ZoomIn, ZoomOut, RotateCcw, X } from 'lucide-react';

export const isTouchDevice = () => typeof window !== 'undefined' && window.matchMedia('(hover: none)').matches;

const ZoomViewer = ({ src, alt, open, onClose }) => (
  <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
    <DialogContent data-testid="zoom-viewer" className="max-w-none w-screen h-[100dvh] p-0 border-0 rounded-none bg-[#0f1a12]/95 backdrop-blur-xl [&>button]:hidden">
      <DialogTitle className="sr-only">{alt} – zoom</DialogTitle>
      <TransformWrapper initialScale={1} minScale={1} maxScale={6} doubleClick={{ mode: 'toggle', step: 1.6 }} centerOnInit>
        {({ zoomIn, zoomOut, resetTransform }) => (
          <div className="relative h-full w-full">
            <TransformComponent wrapperClass="!w-full !h-full" contentClass="!w-full !h-full flex items-center justify-center">
              <img src={src} alt={alt} className="max-h-[85dvh] max-w-[92vw] object-contain drop-shadow-[0_20px_40px_rgba(0,0,0,0.5)]" />
            </TransformComponent>
            <button data-testid="zoom-viewer-close" onClick={onClose} className="absolute top-4 right-4 h-11 w-11 rounded-full bg-white/15 text-white flex items-center justify-center backdrop-blur" aria-label="Close zoom">
              <X className="h-5 w-5" />
            </button>
            <p className="absolute top-5 left-5 text-white/80 text-sm font-medium">{alt}</p>
            <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2 bg-white/15 backdrop-blur rounded-full p-1.5">
              <button data-testid="zoom-out-btn" onClick={() => zoomOut()} className="h-10 w-10 rounded-full text-white flex items-center justify-center hover:bg-white/20" aria-label="Zoom out"><ZoomOut className="h-5 w-5" /></button>
              <button data-testid="zoom-reset-btn" onClick={() => resetTransform()} className="h-10 w-10 rounded-full text-white flex items-center justify-center hover:bg-white/20" aria-label="Reset"><RotateCcw className="h-5 w-5" /></button>
              <button data-testid="zoom-in-btn" onClick={() => zoomIn()} className="h-10 w-10 rounded-full text-white flex items-center justify-center hover:bg-white/20" aria-label="Zoom in"><ZoomIn className="h-5 w-5" /></button>
            </div>
            <p className="absolute bottom-24 left-1/2 -translate-x-1/2 text-white/60 text-xs whitespace-nowrap">Pinch or double-tap to zoom · drag to move</p>
          </div>
        )}
      </TransformWrapper>
    </DialogContent>
  </Dialog>
);

export default ZoomViewer;
